// extracted by mini-css-extract-plugin
export default {"capabilitiesCard":"ZK2RyBUg9t47SxjDWoHs","title":"SZSUkm7Vw5_jtuKafurU","desktopBreak":"yjrTMdsUn_OYfDQn2vau"};